<template>
    <div class="mb-5" v-if="show_msg && maintenance_msg != ''">
        <div class="msg-area w-100">
            {{ maintenance_msg }}
        </div>
    </div>
</template>
<script>
import axios from '@/http';
import Api from '@/config/api';

export default {
    name: 'Maintenance',
    data() {
      return {
        maintenance_msg: '',
        show_msg: false,
      };
    },
    methods: {
        async checkMaintenaceMsg() {
            try {
            const response = await axios.get(Api.endpoints.SITE_INFO);
            if (response.data) {
                const resData = response.data;
                console.log(resData);
                if (resData.data.show_msg == true) {
                this.show_msg = resData.data.show_msg;
                this.maintenance_msg = resData.data.maintenance_msg;
                }
            } else {
                this.show_msg = false;
                this.show_msg = '';
            }
            } catch (error) {
            console.log(error);
            this.show_msg = false;
            this.maintenance_msg = '';
            }
        },
        },
    mounted() {
      this.checkMaintenaceMsg();
    },
  };
</script>
<style>
    .nofound-area h1 {
        font-size: 22px;
        margin-bottom: 30px;
        margin-top: 1%;
        color: #6c6c6e;
    }
    .nofound-area p {
        color: #6c6c6e;
        font-size: 18px;
        margin-bottom: 30px;
        line-height: 25px;
    }
    .msg-area {
        color: #cc0000;
        white-space: pre-line;
    }
</style>
  